import { Button } from "@/components/ui/Button";
import classes from "./ErrorFallback.module.scss";
import { ErrorLayout } from "@/layouts/ErrorLayout";
import { Card } from "@/components/ui/Card";
import { Heading } from "@/components/ui/Heading";
import { Text } from "@/components/ui/Text";
import { TranslationProvider } from "@/contexts/TranslationProvider";
import { AppConfigProvider } from "@/contexts/AppConfigProvider";

export function ErrorFallback() {
  const handleClick = () => {
    window.location.reload();
  };

  return (
    <TranslationProvider>
      <AppConfigProvider>
        <ErrorLayout
          title="Payment processing error"
          sidebarContent={
            <aside className={classes.sidebarContent}>
              <Card>
                <Heading gutterBottom size="xl" as="h2">
                  Try again online
                </Heading>
                <Text gutterBottom>
                  You can restart your donation online. Thank you for your
                  support.
                </Text>
                <Button onClick={handleClick}>Restart donation</Button>
              </Card>
              <Card>
                <Heading gutterBottom size="xl" as="h2">
                  Call us on{" "}
                  <a href="tel:+442074046600" className={classes.link}>
                    020 7404 6600
                  </a>
                </Heading>
                <Text gutterBottom>
                  You can call us between 8am and 10pm. A member of our team
                  will be happy to help.
                </Text>
              </Card>
            </aside>
          }
        >
          <div className={classes.content}>
            <Text gutterBottom size="lg">
              We are sorry but we have been unable to process your donation.
            </Text>
            <Text gutterBottom>
              Donations can fail for a number of reasons. Most often due to an
              incorrect address. Please ensure you enter the address at which
              your payment card is registered.
            </Text>

            <Text gutterBottom>
              Note that although your donation has not been processed, your bank
              or building society may show that it has. If this is the case we
              recommend you contact them.
            </Text>

            <Text gutterBottom>
              Be assured MSF will not attempt to process your donation again if
              it has been declined.
            </Text>

            <Text gutterBottom>Thank you so much for your support.</Text>
          </div>
        </ErrorLayout>
      </AppConfigProvider>
    </TranslationProvider>
  );
}
